import { useCallback, useState } from 'react'
import { useAppSelector } from 'reduxTyped'

import { getTelegramProfile } from 'common/profiles/profileSelectors'
import { handleError } from 'shared/api/lib/errors/handlers'
import { TelegramApi } from 'shared/api/requests/telegram'

import { useTelegramBindingOptIn } from './useTelegramBindingOptIn'

export const useTelegramSignIn = (redirectUrl: string) => {
  const { hasProfile } = useAppSelector(getTelegramProfile)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState<string | null>(null)
  const [code, setCode] = useState<string | null>(null)

  const getOptInUrl = useCallback(async () => {
    setLoading(true)
    try {
      const response = await TelegramApi.getOptInUrl()
      setUrl(response.data.url)
      setCode(response.data.code)

      return response
    } catch (error) {
      handleError(error)
    } finally {
      setLoading(false)
    }

    return null
  }, [])

  useTelegramBindingOptIn(hasProfile, redirectUrl, code)

  return {
    telegramUrl: url,
    getOptInUrl,
    isLoading: loading,
  }
}
